import React from "react"

export default class Pagination extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    buttons = () => {
        const { currentPage, data, handlePage } = this.props
        let n = Math.ceil(data.length / 6) < 5 ? Math.ceil(data.length / 6) : 5
        let start = currentPage > 5 ? currentPage - 5 : 0
        let end = currentPage > 5 ? currentPage : n
        const arr = []

        for (let i = start; i < end; i++) {
            arr.push(<button onClick={e => handlePage(e)} id={i + 1}>{i + 1}</button>)
        }
        return arr
    }


    render() {
        const { data } = this.props
        const totalPages = data !== null && Math.ceil(data.length / 6)
        return (
            <div>
                {this.buttons(totalPages)}
            </div>
        )
    }
}
